"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScenarioGroupOrderByToJSON = exports.ScenarioGroupOrderByFromJSONTyped = exports.ScenarioGroupOrderByFromJSON = exports.ScenarioGroupOrderBy = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var ScenarioGroupOrderBy;
(function (ScenarioGroupOrderBy) {
    ScenarioGroupOrderBy["Name"] = "name";
    ScenarioGroupOrderBy["CreatedBy"] = "createdBy";
    ScenarioGroupOrderBy["CreatedOn"] = "createdOn";
    ScenarioGroupOrderBy["ModifiedBy"] = "modifiedBy";
    ScenarioGroupOrderBy["ModifiedOn"] = "modifiedOn";
})(ScenarioGroupOrderBy = exports.ScenarioGroupOrderBy || (exports.ScenarioGroupOrderBy = {}));
function ScenarioGroupOrderByFromJSON(json) {
    return ScenarioGroupOrderByFromJSONTyped(json, false);
}
exports.ScenarioGroupOrderByFromJSON = ScenarioGroupOrderByFromJSON;
function ScenarioGroupOrderByFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ScenarioGroupOrderByFromJSONTyped = ScenarioGroupOrderByFromJSONTyped;
function ScenarioGroupOrderByToJSON(value) {
    return value;
}
exports.ScenarioGroupOrderByToJSON = ScenarioGroupOrderByToJSON;
